export const webhookEnabling = 'webhookEnabling'
export const testConditionsEnabling = 'testConditionsEnabling'
